import { Component, OnInit } from "@angular/core";
import { AuthService } from "./auth/auth/auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  public constructor(
    public readonly authService: AuthService,
  ) {
  }

  public async ngOnInit(): Promise<void> {
    await this.authService.evaluateLoginStatus();
  }
}
